import React, { useEffect, useState } from 'react'
import { Card, Steps, Tooltip, Collapse } from "antd";
import ReactLoading from "react-loading";
import axios from 'axios'
import Dashboard from "../../layouts/Dashboard";
import moment from "moment";
import { Pagination } from "antd";
import { DatePicker } from "antd";
import { message } from "antd";
import BASE from "../../config"
import { changeDateAndTimeFormat } from "../../utils/commonFunctions"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { usePermissions } from "../../context/PermissionContext";

const { RangePicker } = DatePicker;

function ApiLogs() {
    const exportType = "csv";
    let fileName = `OTP_Logs_Status_${moment(new Date()).format(
      "DD-MM-YYYY_HH:mm"
    )}`;
    const [load, setLoad] = useState(false)
    const [defaultDate, setDefaultDate] = useState([]);
    const [modal, setModal] = useState(false);
    const [logs, setLogs] = useState(null)
    const [current, setCurrent] = useState(1);
    const [requestType, setRequestType] = useState('ALL')
    const [url, setUrl] = useState('')
    const [reqBody, setReqBody] = useState('')
    const { permissions, loading: permsLoading } = usePermissions();
    const canViewApiLogs = permissions.canViewApiLogs;
    const canSubmitApiLogs = true; // Defaulting to true as it's governed by view permission for now, or you can add canSubmitApiLogs to context if needed
    const handleDate = (value, dateString) => {
        if (value === null) {
          setCurrent(1);
          setDefaultDate([
            moment(new Date()).format("YYYY-MM-DD"),
            moment(new Date()).format("YYYY-MM-DD"),
          ]);
        } else {
          setCurrent(1);
          setDefaultDate(dateString);
        }
    };

    const onChange = (page) => {
        setCurrent(page);
    };

    useEffect(() => {
        fetchLogs()
    }, [current])

    async function fetchLogs() {
        
        if(requestType == ""){
            message.warning("Please Select Response Type", 2);
            return
        }
        
        setLoad(true);
          const config = {
            url: BASE.api + `/logs/apiRequestLogs?StartDate=${
                defaultDate[0]
                  ? defaultDate[0]
                  : moment(new Date()).format("YYYY-MM-DD")
              }&EndDate=${
                defaultDate[1]
                  ? defaultDate[1]
                  : moment(new Date()).format("YYYY-MM-DD")
              }&PageNo=${current}&PageSize=10&requestType=${requestType}`,
            method:'get',
            headers: { 
              'Content-Type': 'application/json', 
              'Authorization': `Bearer ${localStorage.getItem('user.token')}`
            },
          }
          try {
            const response = await axios(config);

            console.log("res", response)

            if (response.data && response.data.logList && response.data.logList.length > 0) {
                setLogs(response.data)
                // const data = response?.data?.logData.map((ele) => {
                //   return {
                //     _id: ele._id,
                //     name: ele.name,
                //     user: ele.user,
                //     createdAt: ele.createdAt,
                //     updatedAt: ele.updatedAt,
                //     description: ele.description ? JSON.parse(ele.description) : "",
                //   };
                // });
                // console.log("final data", data);
                // exportFromJSON({ data, fileName, exportType });
              } else {
                setLogs([])
                message.warning("No Data Available", 2);
              }
    
            setLoad(false);
          } catch (e) {
            setLoad(false);
          }        
      }


      const toggle = (url,data) => {
        setUrl(url)
        setReqBody(JSON.stringify(data))
        setModal(!modal);
      };

      function truncateText(text = "none", maxLength) {
        if (text.length > maxLength) {
          return text.substring(0, maxLength) + "...";
        } else {
          return text;
        }
      }


    
  if (permsLoading) {
    return (
        <Dashboard title="API Logs">
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
        </Dashboard>
    );
  }

  if (!canViewApiLogs) {
    return (
        <Dashboard title="API Logs">
            <div className="alert alert-danger">You do not have permission to view this page.</div>
        </Dashboard>
    );
  }

  return (
    <>
      <Dashboard title="API Logs">
      {
        load && 
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" /> 
      }
        <div className='row'>
            <div className='col-12'>
                <Card title="Filters" className="border mt-3">
                    <div className='row align-items-ceter'>
                        <div className="col-md-3">
                            <select
                                id="FormType"
                                className="mb-2 form-control"
                                onChange={(e) => setRequestType(e.target.value)}
                            >
                                <option value="" >Select Request Type</option>
                                <option value='ALL' selected="true">ALL</option>
                                <option value='POST'>POST</option>
                                <option value='DELETE'>DELETE</option>
                                <option value='PUT'>PUT</option>
                                <option value='PATCH'>PATCH</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <RangePicker
                                style={{height:'37px'}}
                                className=""
                                format="YYYY-MM-DD"
                                defaultValue={[moment(), moment()]}
                                onChange={handleDate}
                                // disabledDate={disabledDate}
                                placeholder={[
                                    moment(new Date()).format("YYYY-MM-DD"),
                                    moment(new Date()).format("YYYY-MM-DD"),
                                ]}
                            />
                        </div>
                        <div className="col-md-3">
                            {canSubmitApiLogs && (
                                <button
                                    className={`btn ${true ? "btn-primary" : "btn-secondary"}`}
                                    type="submit"
                                    onClick={fetchLogs}
                                >
                                    Submit
                                </button>
                            )}
                        </div>
                    </div>
                </Card>
            </div>
                <div className='col-12'>
                    <Card className='mt-4' style={{width:'100%'}}>
                        <table className="table bg-white ">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Request Type</th>
                                <th>Request Url</th>
                                <th>createdAt</th>
                            </tr>
                            </thead>
                            <tbody>
                            {logs?.logList?.map((ele) => {
                                return (
                                <tr>
                                    <td>{ele.name}</td>
                                    <td>{ele.email}</td>
                                    <td>{ele.requestType}</td>
                                    {ele?.requestUrl?.length > 0 ? (
                                    <td
                                        style={{ color: "#0081C9" }}
                                        onClick={() => toggle(ele?.requestUrl,ele?.reqBody)}
                                    >
                                        {truncateText(ele?.requestUrl, 30)}
                                    </td>
                                    ) : (
                                    <td style={{ color: "red" }}>none</td>
                                    )}
                                    <td>{changeDateAndTimeFormat(ele.createdAt)}</td>
                                </tr>
                                );
                            })}
                            </tbody>
                        </table>
                        <Pagination
                            showSizeChanger = {false}
                            current={current}
                            onChange={onChange}
                            total={logs?.logCount}
                        />
                    </Card>
                </div>
        </div>
    </Dashboard>
    <Modal isOpen={modal} toggle={() => toggle("cancel")}>
          <ModalHeader toggle={() => toggle("cancel")}>
            Log description
          </ModalHeader>
          <ModalBody>
            <div style={{ width: "100%", wordWrap: "anywhere" }}>
              <p>{url}</p>
              <p>{reqBody}</p>
            </div>
          </ModalBody>
          <ModalFooter>
            {/* <Button color="primary" >
              Update
            </Button>{" "}
            <Button color="secondary" onClick={() => toggle("cancel")}>
              Cancel
            </Button> */}
          </ModalFooter>
        </Modal>
    </>
  )
}

export default ApiLogs